import { criptObjectOnLocalStorage, criptoLocalStorage } from '../../modulos/cripotografia/criptoStorage';
import { retornoHashValor } from '../../modulos/cripotografia/hash';
import { BuscarAreaDeAtuacao, BuscarInfosPerfil } from '../associados';

const url = retornoHashValor(process.env.REACT_APP_1);
const token = localStorage.getItem('token');

let perfil;
let retorno;

export const Buscar = async cod => {
    try {
        switch (cod) {
            case '1':
                perfil = 'vendedor';
                break;
            case '2':
                perfil = 'coordenador';
                break;
            case '3':
                perfil = 'supervisor';
                break;
            case '7':
            case '5':
            case '10':
            case '12':
                perfil = 'analista';
                break;
            case '8':
                perfil = 'gerente';
                break;
            default:
                perfil = 'vendedor';
                break;
        }

        const response = await BuscarInfosPerfil(perfil);

        if (response) {
            const dados = response.data[0];

            retorno = dados ? dados : response.data;

            if (retorno.vendedor_codigo && (perfil === 'supervisor' || perfil === 'coordenador')) {
                criptoLocalStorage('perfilPossivel', '1');

                if (retorno.Status !== 'I') {
                    perfil === 'supervisor' && criptoLocalStorage('USRSUP', 'true');
                    perfil === 'coordenador' && criptoLocalStorage('USRCOO', 'true');
                }
            }

            const areaAtuacao = await BuscarAreaDeAtuacao(retorno.codigo, perfil);

            !areaAtuacao.erro && (criptObjectOnLocalStorage('area', areaAtuacao[0].Codigo));
        } else {
            retorno = { erro: 'parametros errados' };
        }

        return retorno;
    } catch (error) {
        console.log(error);

        return error;
    }
};

export const Atualizar = async cod => {
    await fetch(`${url}/vendedor/${cod.cod}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'x-auth-token': token
        },
        body: JSON.stringify(cod)
    })
        .then(response => {
            retorno = response;
        })
        .catch(err => {
            throw new Error(err);
        });

    return retorno;
};
